module.exports = __webpack_public_path__ + "static/img/news7_img.fbeff43.png";